import { useImperativeHandle, forwardRef } from 'react'
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js'

const PaymentMethod = forwardRef((props, ref) => {

    const stripe = useStripe()
    const elements = useElements()

    // Submit the payment method to stripe
    const SubmitPaymentMethod = async () => {

        if (!stripe || !elements) return null

        // Create the payment method in stripe

        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardElement),
        })

        if (error) {
            console.error(error)
            return null
        }

        return paymentMethod
        
    }

    // Expose the SubmitPaymentMethod function to the parent component
    useImperativeHandle(ref, () => ({ SubmitPaymentMethod: SubmitPaymentMethod }));

    return (
        <div className="border border-gray-300 px-3 py-2 rounded-md -my-2">
            <CardElement />
        </div>
    )
})

export default PaymentMethod
